import { PricingSegment as _PricingSegment } from '@team-milva/lab-models/pricingSegment'

export class PricingSegment extends _PricingSegment {
  getLabel(locale: string): string {
    return `${this.getName(locale)} (${this.currencyCode})`
  }
}

